"use strict";

var _taggedTemplateLiteral = require("/home/node/workspace/viz-client/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js").default;
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Crosshair = function Crosshair(_ref) {
  var x = _ref.x,
    xVal = _ref.xVal,
    y = _ref.y,
    yVal = _ref.yVal,
    marginObj = _ref.marginObj,
    width = _ref.width,
    height = _ref.height,
    _ref$axisData = _ref.axisData,
    axisData = _ref$axisData === void 0 ? true : _ref$axisData;
  return react_1.default.createElement("g", null, react_1.default.createElement(StyledTargetCircle, {
    cx: x,
    cy: y,
    r: 5
  }), react_1.default.createElement("g", {
    id: 'x',
    transform: "translate(".concat(x, ")")
  }, react_1.default.createElement(StyledCrosshair, {
    x1: 0,
    x2: 0,
    y1: marginObj.top,
    y2: height - marginObj.bottom
  }), axisData && react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(StyledAxisRect, {
    orientation: 'x',
    y: height - marginObj.bottom,
    width: "".concat(xVal.toString().split('').length, "ch"),
    rx: '2'
  }), react_1.default.createElement(StyledAxisHighlight, {
    orientation: 'x',
    y: height - marginObj.bottom + 4
  }, xVal))), react_1.default.createElement("g", {
    id: 'y',
    transform: "translate(0,".concat(y, ")")
  }, react_1.default.createElement(StyledCrosshair, {
    x1: marginObj.left,
    x2: width - marginObj.right,
    y1: 0,
    y2: 0
  }), axisData && react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(StyledAxisRect, {
    orientation: 'y',
    x: width - marginObj.right,
    width: marginObj.right,
    rx: '2'
  }), react_1.default.createElement(StyledAxisHighlight, {
    orientation: 'y',
    x: width - marginObj.right / 2
  }, yVal))));
};
exports.default = react_1.default.memo(Crosshair);
var StyledAxisRect = styled_components_1.default.rect(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 1em;\n  fill: var(--highlight);\n  transform-box: fill-box;\n  transform: ", ";\n"])), function (_ref2) {
  var orientation = _ref2.orientation;
  return orientation === 'y' ? 'translateY(-50%)' : 'translate(-50%, 2px)';
});
var StyledAxisHighlight = styled_components_1.default.text(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  fill: var(--text-primary);\n  alignment-baseline: ", ";\n  text-anchor: middle;\n  font-size: 0.75em;\n"])), function (_ref3) {
  var orientation = _ref3.orientation;
  return orientation === 'y' ? 'central' : 'hanging';
});
var StyledTargetCircle = styled_components_1.default.circle(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  stroke: var(--highlight);\n  opacity: 0.75;\n  fill: none;\n"])));
var StyledCrosshair = styled_components_1.default.line(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  stroke: var(--highlight);\n  stroke-dasharray: 2px;\n  opacity: 0.75;\n"])));